import cuid from '@paralleldrive/cuid2'
import { cloneDeep } from 'lodash-es'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import { createArtificialAppointments } from '@/functional/artificialAppointments'
import type { Nilable } from '@/types/misc'

type Resource = {
  id: number
  startDate?: Date | undefined
  endDate?: Date | undefined
  resourceFunction?: Nilable<{
    sortOrder?: Nilable<number>
  }>
}

export function useArtificialAppointments(options: {
  resources: MaybeRefOrGetter<Nilable<(Resource | null)[]>>
  containerStartDate: MaybeRefOrGetter<Date | undefined>
  containerEndDate: MaybeRefOrGetter<Date | undefined>
}) {
  const artificialAppointments = computed(() => {
    return (
      createArtificialAppointments({
        resources: toValue(options.resources),
      }) ?? []
    )
  })

  const appointments = computed(() => {
    return artificialAppointments.value.map((appointment) => {
      const id = cuid.createId()

      return {
        ...cloneDeep(appointment),
        id,
        props: {
          id,
          title: '- ohne Termin -',
          containerStartDateUnconstrained: toValue(options.containerStartDate),
          containerEndDateUnconstrained: toValue(options.containerEndDate),
          startDate: appointment.startDate,
          endDate: appointment.endDate,
          isWithDetails: false,
        },
      }
    })
  })

  const itemsForContentBounds = computed(() => {
    return artificialAppointments.value.map((appointment) => {
      return {
        startDate: appointment.startDate,
        endDate: appointment.endDate,
      }
    })
  })

  return {
    appointments,
    itemsForContentBounds,
  }
}
